mutation LeadRemoveChannel($input: LeadRemoveChannelInput!) {
    leadRemoveChannel(input: $input) {
        lead {
            id
        }
    }
}
